<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="488">
    <div class="white pa-8">
      <v-row>
        <v-col cols="12">
          <p class="form__title primary--text mb-2">
            GRUPO ECONÔMICO CRIADO COM SUCESSO!
          </p>
          <p class="font-weight-medium darkBluishGray--text mb-12">
            {{ textNotification }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="3" class="pr-2">
          <BaseButton
            outlined
            color="secondary"
            v-html="'NÃO'"
            @click="$emit('close')"
            width="100%"
          />
        </v-col>
        <v-col cols="3">
          <BaseButton
            class="secondary"
            v-html="'SIM'"
            @click="$emit('new')"
            width="100%"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
export default {
  props: {
    textNotification: {
      type: String,
      default: "Você deseja criar um novo tomador matriz ou filial?"
    }
  }
};
</script>